import React from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

const S3Plugin = React.lazy(() => importFromS3('tcc-data-hub'));
const MFPlugin = React.lazy(() => import('dataHub/DataHub'));

export const DataHubPluginContainer: React.FC<{ operationsSelected: Operation[] }> = ({ operationsSelected }) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.dataHub.module-federation'];

  const DataHubPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  return <DataHubPlugin
    operationsSelected={operationsSelected}
    shouldRenderFarmerNav={false}
  />;
};
